import { render, staticRenderFns } from "./K-2-1a_EDMreport_Review Picture.vue?vue&type=template&id=7c9400f3&scoped=true&"
import script from "./K-2-1a_EDMreport_Review Picture.vue?vue&type=script&lang=js&"
export * from "./K-2-1a_EDMreport_Review Picture.vue?vue&type=script&lang=js&"
import style0 from "./K-2-1a_EDMreport_Review Picture.vue?vue&type=style&index=0&id=7c9400f3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c9400f3",
  null
  
)

export default component.exports